module.exports = __webpack_public_path__ + "static/media/header-bg.dc4c97ca.png";